import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getFeatureFlag = {
  name: "getFeatureFlag" as const,
  input: z.object({ flagKey: createEnum(FeatureFlagKey) }),
  output: z.object({ enabled: z.boolean() }),
};
